// export const BASE_URL = "http://localhost:8500/"
export const BASE_URL = "https://api.jsvsapp.in/"

export const API_URL_ENDPOINT = {
    //Universal Search
    FIND_USER_BY_TOKEN : "api/User/getUserByToken",
    FIND_ROOM_BY_ID : "api/Live/getRoomByID",
    UPDATE_USER_MINUTE : "api/Live/updateUserLiveMinute",
    SEND_SEAT_REQUEST : "api/Live/sendSeatRequest",
    SEAT_REQUEST_LIST : "api/Live/getSeatRequestList",
    ACTION_ON_REQUEST : "api/Live/actionOnSeatRequest", 
    REMOVE_FROM_SEAT : "api/Live/removeUserFromSeat",
    GET_LIVE_MEMBERS : "api/Live/getLiveMembers",
    GET_REWARD_DATA : "api/User/getRewardDetails",
    GET_EMPTY_SEAT : "api/Live/getEmptySeat",

    GET_CONTENT : "api/Content/getContent",
    GET_CONTENT_INDEX : "api/Content/getContentIndex",
    GET_CONTENT_BODY : "api/Content/getContentBody"
}
